import axios, { AxiosError } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { Api } from '../axiosApi';

export interface IListagemContasPagar {
  idpagar: string;
  emissao: Date;
  vencimento: Date;
  nome: string;
  cpf: string;
  parcela: string;
  nossonumero: string;
  numero: string;
  vcompra: number;
  logo: string;
  vpago: number;
  desconto: number;
  acrescimo: number;
  vparcela: number;
  status: boolean;
  marcado: boolean;
  vpagar: number;
  venc: boolean;
  boleto: boolean;
}
export interface IMarcados{
  idpagar: string;
	marcado: boolean;
	desconto: number;
	vpagar: number;
}
export interface ICheque{
  idcheque: string;
  banco: string;
  agencia: string;
  conta: string; 
  datadeposito: Date;
  titular: string;
  valor: number;
  numero: string;
}
type TotalCount = {
    data: IListagemContasPagar[];
    totalCount: number;
    selecionado: number;
    total: number;
}
interface IPagas {
  vpagar: number;
  vselecionado: number;
  idconta: string;
  databaixa: Date;
  numeroch: string;
  tipocaixa: boolean;
  formasPagamento?: { idoperacao: string; valor: number; categoria?: string; idcontadestino?: string }[];
}
interface IPagar {
  emissao: Date;
  vencimento: Date;
  vpagar: number;
  vpago: number;
  vparcela: number;
  vcompra: number;
  parcela: string;
  idplanoconta: string;
  numero: string;
  tipopagamento: string;
  tipo: number;
  desconto: number;
  acrescimo: number;
  historico: string;
  idparceiro: string;
}
// Parcelas do mesmo lançamento (mesmo parceiro + número) — ver GetById.ts, backend.
export interface IParcelaLancamentoPagar {
  idpagar: string;
  parcela: string;
  numero: string;
  vencimento: Date;
  vparcela: number;
  status: boolean;
  pagas: number;
}
interface IGetPagar {
  parcelas?: IParcelaLancamentoPagar[];
  idpagar: string;
  emissao: Date;
  vencimento: Date;
  vpagar: number;
  vpago: number;
  vparcela: number;
  vcompra: number;
  parcela: string;
  idplanoconta: string;
  numero: string;
  tipopagamento: string;
  tipo: number;
  desconto: number;
  acrescimo: number;
  historico: string;
  idparceiro: string;
}
interface IUpdatePagar {
  emissao: Date;
  vencimento: Date;
  vpagar: number;
  vpago: number;
  vparcela: number;
  vcompra: number;
  parcela: string;
  idplanoconta: string;
  numero: string;
  tipopagamento: string;
  tipo: number;
  desconto: number;
  acrescimo: number;
  historico: string;
  idparceiro: string;
}
interface IParcelas {
  // Mesmo valor em todas as parcelas do lançamento — ver TemIdlote.ts, backend.
  idlote?: string;
  idpagar: string;
  emissao: Date;
  vencimento: Date;
  vpagar: number;
  vpago: number;
  vparcela: number;
  vcompra: number;
  parcela: string;
  idplanoconta: string;
  numero: string;
  tipopagamento: string;
  tipo: number;
  desconto: number;
  acrescimo: number;
  historico: string;
  idparceiro: string;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
export interface IBaixaFolha {
  datalan: Date;
  idfazenda: string;
  numerodoc: string;
  valor: number;
}
const create = async (dados: IPagar): Promise<string | Error> => {
  try {   
    const guuid = uuidv4();
    const { data } = await Api.post<IPagar>('/contaspagar',  [{idpagar: guuid, ...dados}]);
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const createparcelas = async (dados: IParcelas[]): Promise<string | Error> => {
  try {
    const guuid = dados[0].idpagar;
    const { data } = await Api.post<IParcelas>('/contaspagar',  dados);
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados: IUpdatePagar): Promise<void | Error> => {
  try {
    await Api.put(`/contaspagar/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAll = async (page = 1, dataInicial = '', dataFinal = '', filter = '', tipo = '', limit = 9999 ): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/contaspagar?page=${page}&limit=${limit}&filter=${filter}&tipo=${tipo}&datainicial=${dataInicial}&datafinal=${dataFinal}`;
    const { data, headers } = await Api.get(urlRelativa);  
     
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || limit),
        selecionado: Number(headers['x-total-selecionado'] || 0),
        total: Number(headers['x-total-valor'] || 0),
      }; 
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const Marcados = async (dados: IMarcados[]): Promise<void | Error> => {
  try {
    await Api.post('/contaspagarmarcado', dados);    
    return;

  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const BaixaFolha = async (dados: IBaixaFolha): Promise<void | Error> => {
  try {
    await Api.post('/baixafolha', dados);    
    return;
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Baixa = async (dados: IPagas, pagar: IListagemContasPagar[]): Promise<void | Error> => {
  try {  
    let historicos = ''; 
    if(dados.vpagar === dados.vselecionado){
      const baixa = pagar.map(conta => {
        historicos += `${conta.numero}, `;
        return {
          idpagar: conta.idpagar,
          idconta: dados.idconta,
          datalan: dados.databaixa,
          valor: conta.vpagar,
          numeroch: dados.numeroch,
          historico: `Pagamentos dos numeros ${historicos.slice(0, -2)}`,
          total: dados.vselecionado,
          tipocaixa: dados.tipocaixa,
          formasPagamento: dados.formasPagamento,
        };
      });
      await Api.post('/contaspagarbaixa', baixa);
      return;
    }else{
      const baixa = pagar.map(conta => {
        return {
          idpagar: conta.idpagar,
          idconta: dados.idconta,
          datalan: dados.databaixa,
          valor: dados.vpagar,
          numeroch: dados.numeroch,
          formasPagamento: dados.formasPagamento,
        };
      });
      await Api.post('/contaspagarbaixaparcial', baixa);
      return;
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};


const getById = async (id: string): Promise<IGetPagar | Error> => {
  try {
    const { data } = await Api.get(`/contaspagar/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
// Sempre apaga todas as parcelas do lançamento — não existe apagar uma
// parcela sozinha (ver DeleteById.ts, backend).
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/contaspagar/${id}`);
  }catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const ContasPagarService = {  
  getAll,
  Marcados,
  Baixa,
  create,
  updateById,
  getById,
  deleteById,
  createparcelas, 
  BaixaFolha,
};